<vcl-dialog
  [showDialog]="this.loadExitScreen"
  [buttonLabels]="copyService.copies.header_exit_button"
  [dialogTitle]="copyService.copies.header_exit_button.title"
  (dialogButtonClick)="goExit()"
  [id]="'dialogClose'"
  [buttonAlignment]="'horizontal'"
>
  <p id="dialogDescription">
    {{ copyService.copies.header_exit_button.description }}
  </p>
</vcl-dialog>

<div class="content-with-stepper-and-title">
  <div class="row">
    <div
      *ngIf="
        product_type == 'livingPlace' &&
        !abreCuentasService.viewOptionMultiProduct
      "
      class="col-4 col-pr-12 col-sm-8 col-md-12"
    >
      <div class="box-title">
        <p class="sub-title mt-2" id="subtitle">
          {{ documentInfo.firstname }}, {{ screenCopies.mainText }}
          {{ textApproved }} {{ subline }}
        </p>
      </div>

      <div class="box-desc">
        <p class="copy-1 mt-3">{{ screenCopies_title.mailInfo }}</p>
        <p class="copy-1 mt-3" id="documents-container">
          Consulta los
          <a (click)="showRequiredDocuments()"><u>documentos</u></a> que
          necesitarás para realizar esta solicitud
        </p>
        <div class="divider mt-3"></div>

        <div class="detail">
          <div class="case-detail case-detail-bold">
            <p>
              <span
                ><strong>{{ screenCopies.text_zona_gris }}</strong></span
              >
            </p>
          </div>
          <br />
          <div class="case-id">
            <p class="subtitle subtitle-light">{{ labelValue }}</p>
            <p class="money">${{ showAmount }}</p>
          </div>
          <div class="case-id">
            <p class="subtitle subtitle-light">{{ screenCopies.plazo }}</p>
            <p>{{ mes }} meses</p>
          </div>
          <div class="case-id" *ngIf="showRate">
            <p class="subtitle subtitle-light">{{ screenCopies.tasa }}</p>
            <p>{{ rateLiving }}</p>
            <p>{{ screenCopies.tasa_two }}</p>
          </div>
          <div *ngIf="purchase" class="case-id">
            <p class="subtitle subtitle-light">{{ screenCopies.compra }}</p>
            <p>{{ purchasePercent }}% del credito.</p>
          </div>
          <div class="case-id">
            <p class="subtitle subtitle-light">{{ screenCopies.solicitud }}</p>
            <p>{{ caseNum }}</p>
          </div>
          <div class="case-detail">
            <p>
              <span>{{ screenCopies.description2 }}</span>
            </p>
          </div>
          <div class="divider mt-3"></div>
          <div class="case-detail">
            <p>
              <span>{{ screenCopies.submaintext }}</span>
            </p>
          </div>
          <div class="box-desc">
            <div id="steps">
              <ul class="mt-3">
                <vcl-list>
                  <li *ngFor="let option of options" vclListSimple>
                    <span id="iconCheck" class="icon icon-itaufonts_check">
                    </span>
                    <vcl-list-text class="list">
                      {{ option.value.replace('%s', amountPco) }}
                    </vcl-list-text>
                  </li>
                </vcl-list>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="
        product_type != 'livingPlace' &&
        !abreCuentasService.viewOptionMultiProduct
      "
      class="col-4 col-pr-12 col-sm-8 col-md-12"
    >
      <div class="box-title">
        <p *ngIf="product_type != 'loan'" class="sub-title mt-2" id="subtitle">
          {{ documentInfo.firstname }}, {{ screenCopies.mainText }}
          <strong *ngIf="product_type != 'loan'">{{
            screenCopies.spanText
          }}</strong>
        </p>
      </div>

      <div class="box-title">
        <p
          *ngIf="product_type == 'loan'"
          class="sub-title-loan mt-2"
          id="subtitle"
        >
          {{ documentInfo.firstname }}, {{ screenCopies.mainText }}
        </p>
      </div>

      <div *ngIf="product_type == 'loan'" class="case-id mt-2">
        <p class="número-de-solicitud">{{ screenCopies.solicitud }}</p>
        <p class="caso">{{ codBizagi }}</p>
      </div>

      <div class="box-desc">
        <p class="copy-1 mt-3">{{ screenCopies_title.mailInfo }}</p>
        <p class="copy-1 mt-3" id="documents-container">
          Consulta los
          <a (click)="showRequiredDocuments()"><u>documentos</u></a> que
          necesitarás para realizar esta solicitud
        </p>
        <p
          *ngIf="product_type == 'loan'"
          class="copy-1 mt-3"
          id="documents-container"
        >
          {{ screenCopies.description2 }}
        </p>
        <div class="divider mt-3"></div>

        <div *ngIf="product_type == 'loan'" class="detail">
          <div class="case-detail-loan">
            <p>
              <strong>{{ screenCopies.text_zona_gris }}</strong>
            </p>
          </div>
          <div class="case-id mt-2">
            <p class="subtitle">{{ screenCopies.valor }}</p>
            <p class="title_one">${{ amountPco }}</p>
          </div>
          <div class="case-id">
            <p class="subtitle">{{ screenCopies.plazo }}</p>
            <p>{{ mes }} meses</p>
          </div>
          <div class="case-id" *ngIf="showRate">
            <p class="subtitle">{{ screenCopies.tasa }}</p>
            <p>{{ rateLiving }}</p>
            <p>{{ screenCopies.tasa_two }}</p>
          </div>
          <voxel-accordion-group>
            <voxel-accordion accordionTitle="Beneficios" class="edithStyles">
              <ul>
                <vcl-list>
                  <li *ngFor="let option of loanBenefits" vclListSimple>
                    <span id="iconCheck" class="icon icon-itaufonts_check">
                    </span>
                    <vcl-list-text class="list">
                      {{ option.value }}
                    </vcl-list-text>
                  </li>
                </vcl-list>
              </ul>
            </voxel-accordion>
          </voxel-accordion-group>
        </div>

        <div *ngIf="product_type == 'revolvingCredit'" class="detail2">
          <div class="case-id">
            <p class="subtitle">{{ screenCopies_title.caseLabel }}</p>
            <p>{{ codBizagi }}</p>
          </div>
          <p class="description2">{{ screenCopies.description2 }}</p>
          <p class="description">{{ screenCopies.description }}</p>
        </div>

        <div *ngIf="product_type == 'freeInvestment'" class="detail">
          <div class="case-detail">
            <p>
              <span>{{ screenCopies.text_zona_gris }}</span>
            </p>
          </div>
          <div class="case-id">
            <p class="title_one">${{ amountPco }}</p>
            <p class="subtitle">{{ screenCopies.valor }}</p>
          </div>
          <div class="case-id">
            <p class="subtitle">{{ screenCopies.plazo }}</p>
            <p>{{ mes }} meses</p>
          </div>
          <div class="case-id" *ngIf="showRate">
            <p class="subtitle">{{ screenCopies.tasa }}</p>
            <p>{{ rateLiving }}</p>
            <p>{{ screenCopies.tasa_two }}</p>
          </div>

          <div class="case-id">
            <p class="subtitle">{{ screenCopies_title.caseLabel }}</p>
            <p>{{ codBizagi }}</p>
            <p></p>
            <p class="description2">{{ screenCopies.description2 }}</p>
          </div>

          <div class="case-detail">
            <p>
              <span>{{ screenCopies.submaintext }}</span>
            </p>
          </div>
          <div id="steps">
            <ul class="mt-3">
              <vcl-list>
                <li *ngFor="let option of options" vclListSimple>
                  <span id="iconCheck" class="icon icon-itaufonts_check">
                  </span>
                  <vcl-list-text class="list">
                    {{ option.value }}
                  </vcl-list-text>
                </li>
              </vcl-list>
            </ul>
          </div>
        </div>
        <div *ngIf="product_type === 'creditCard'" class="detail">
          <div class="case-detail">
            <p>
              <span>{{ screenCopies.text_zona_gris }}</span>
            </p>
          </div>
          <div class="case-id">
            <p class="title_one">${{ amountPco }}</p>
            <p class="subtitle">{{ screenCopies.valor }}</p>
          </div>
          <div class="case-id">
            <p class="subtitle">{{ screenCopies.plazo }}</p>
            <p>{{ mes }} meses</p>
          </div>
          <div class="case-id" *ngIf="showRate">
            <p class="subtitle">{{ screenCopies.tasa }}</p>
            <p>{{ rateLiving }}</p>
            <p>{{ screenCopies.tasa_two }}</p>
          </div>

          <div class="case-id">
            <p class="subtitle">{{ screenCopies_title.caseLabel }}</p>
            <p>{{ codBizagi }}</p>
            <p></p>
            <p class="description2">{{ screenCopies.description2 }}</p>
          </div>

          <div class="case-detail">
            <p>
              <span>{{ screenCopies.submaintext }}</span>
            </p>
          </div>
          <div id="steps">
            <ul class="mt-3">
              <vcl-list>
                <li *ngFor="let option of options" vclListSimple>
                  <span id="iconCheck" class="icon icon-itaufonts_check">
                  </span>
                  <vcl-list-text class="list">
                    {{ option.value }}
                  </vcl-list-text>
                </li>
              </vcl-list>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="abreCuentasService.viewOptionMultiProduct"
      class="col-4 col-pr-12 col-sm-8 col-md-12"
    >
      <div class="box-title">
        <p class="sub-title1" id="subtitle">
          {{ screenCopies.text_zona_gris_2 }}
        </p>
      </div>
      <div class="detail">
        <div class="case-id">
          <p class="subtitle subtitle-light">{{ screenCopies.solicitud }}</p>
          <p>{{ codBizagi }}</p>
        </div>
        <p class="copy-3 mt-3">{{ documentInfo.firstname }}, {{ prueba }}</p>
        <p class="copy-1 mt-3">{{ screenCopies.head_description_aux }}</p>
        <p class="copy-1 mt-3" id="documents-container">
          Consulta los
          <a (click)="showRequiredDocuments()"><u>documentos</u></a> que
          necesitarás para realizar esta solicitud
        </p>
        <p class="copy-1 mt-3">
          {{ screenCopies.successful_account_creation_extra_text_zng }}
        </p>
        <br />
      </div>
      <div class="list-product">
        <div *ngFor="let row of this.abreCuentasService.getProductsSelects()">
          <div class="product" *ngIf="isGranted(row.product_type)">
            <strong>{{ row.name }}</strong>
            <div
              *ngIf="row.product_code === 'ORD' || row.product_code === 'LBR'"
              class="detail"
            >
              <div class="box-desc">
                <div class="case-id">
                  <p class="subtitle subtitle-light">
                    {{ copyService.copies.offer_multi.valor }}
                  </p>
                  <p class="money">${{ showAmount }}*</p>
                </div>
                <div class="case-id">
                  <p class="subtitle subtitle-light">
                    {{ screenCopies.plazo }}
                  </p>
                  <p>{{ mes }} meses</p>
                </div>
                <div class="case-id" *ngIf="showRate">
                  <p class="subtitle subtitle-light">{{ screenCopies.tasa }}</p>
                  <p>{{ rateLiving }}</p>
                  <p>{{ screenCopies.tasa_two }}</p>
                </div>
                <div *ngIf="purchase" class="case-id">
                  <p class="subtitle subtitle-light">
                    {{ screenCopies.compra }}
                  </p>
                  <p>{{ purchasePercent }}% del credito.</p>
                </div>
                <div class="divider mt-3"></div>
              </div>
            </div>
            <br />
            <voxel-accordion-group>
              <voxel-accordion accordionTitle="Beneficios" class="edithStyles">
                <ul>
                  <vcl-list *ngIf="row.product_type != 'creditCard'">
                    <li *ngFor="let option of listBenefits(row)" vclListSimple>
                      <span id="iconCheck" class="icon icon-itaufonts_check">
                      </span>
                      <vcl-list-text class="list">
                        {{ option.value }}
                      </vcl-list-text>
                    </li>
                  </vcl-list>
                </ul>
                <div class="alliances" *ngIf="row.product_type == 'creditCard'">
                  <div id="card_alliances" class="content-alliances">
                    <vcl-card-template
                      *ngFor="let alliance of listBenefits(row)"
                      image="assets/images/{{ alliance.img }}"
                      [title]="alliance.name"
                      [paragraph]="alliance.body"
                      buttonAlignment="vertical"
                    >
                    </vcl-card-template>
                    <p class="copy-1 mt-3">
                      {{
                        copyService.copies
                          .message_grayzone_existent_find_more_information1
                      }}
                      <strong>Dias Itaú</strong>,
                      {{
                        copyService.copies
                          .message_grayzone_existent_find_more_information2
                      }}
                    </p>
                    <br />
                    <strong *ngIf="channelId == '141'">{{
                      copyService.copies
                        .message_grayzone_existent_find_more_information_link
                    }}</strong>

                    <a
                      *ngIf="channelId != '141'"
                      class="link"
                      [href]="
                        copyService.copies
                          .message_grayzone_existent_find_more_information_link
                      "
                      target="_blank"
                    >
                      {{
                        copyService.copies
                          .message_grayzone_existent_find_more_information_link
                      }}
                    </a>
                    <br />
                  </div>
                </div>
              </voxel-accordion>
            </voxel-accordion-group>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-controls
    id="gra-zone"
    [hasPrevious]="true"
    [previousLabel]="copyService.copies.offer_resolvinf_credit.volver"
    [nextLabel]="copyService.copies.offer_resolvinf_credit.button"
    (previous)="previous()"
    (next)="next()"
  >
  </app-controls>
</div>
